module.exports = __webpack_public_path__ + "img/CASSANDRA.2b8c7aa7.png";